import { Text, Button, Center, Flex } from "@mantine/core";
import { modals } from "@mantine/modals";

import SRD_Form from "components/Form";
import React, { useState, useEffect ,useCallback} from "react";
import Clipboard from '@react-native-clipboard/clipboard';
//import {CopyToClipboard} from "react-copy-to-clipboard";

import { useNavigate, useLocation } from "react-router-dom";
import {
  deleteUserInfo,
  getSellUser,
  updateUserInfo,
  requestNewPassword,
} from "../apis/adminUserApis";

import { useRecoilState } from "recoil";
import { groupListState } from "components/Form/atom/groupListState";
import { levelListState } from "components/Form/atom/levelListState";
import { getPathname } from "utils/getPathname";
import { userState } from "pages/Login/atom/userState";

function UserEditForm() {
  
  const [user, setUser] = useRecoilState(userState);
  const level = Number(user?.fn_level);
  const [initLevelList, setInitLevelList] = useRecoilState(levelListState);
  const username = getPathname();
  const [defaultValues, setDefaultValues] = useState();
  const [groupList, setGroupList] = useRecoilState(groupListState);
  const [,updateState] = useState();
  const userLevelList = initLevelList.filter(item => Number(item.value) >= level);  

  useEffect(() => { 
    getSellUser(username).then((res) => setDefaultValues(res));   
  }, []);

  const location = useLocation();
  let backPage = 1;
  let backGroup;
  if (location.state) {
    backPage = location.state.pg;
    backGroup = location.state.group;
  }

  const backToList = () => {
    const params = new URLSearchParams({page: String(backPage)});
    if (backGroup !== undefined && backGroup !== null) {
      params.set("group", backGroup);
    }
    navigate(`/admin/user?${params.toString()}`, {replace: true});
  };

  const navigate = useNavigate();
  const fields = [
    {
      key: "user_id",
      name: "아이디",
      type: "id",
      disabled: true,
    },
  /*  
    {
      key: "password",
      name: "비밀번호",
      type: "password",
    },
    {
      key: "confirm_password",
      name: "비밀번호 확인",
      type: "confirm_password",
    },
  */
    { key: "fn_name", name: "이름", type: "text" },
    {
      key: "fn_level",
      name: "사용자레벨",
      type: "select",
      options: userLevelList,
    },
    {
      key: "fn_group_id",
      name: "소속그룹",
      type: "select",
      options: groupList,
    },
    { key: "fn_mobile_nbr", name: "전화번호", type: "phone_number" },
    { key: "fn_address", name: "주소", type: "text" },
  ];

  const onSubmit = (e) => {
    modals.openConfirmModal({
      title: "수정",
      children: <Center>수정 하시겠습니까?</Center>,
   //   centered: true,
      zIndex: 2000,
      labels: { confirm: "수정", cancel: "취소" },
      onConfirm: () => {
        updateUserInfo(e);
        backToList();
      },
    });
  };

/*
  const copyToClipboard = async (text) => {
    if (navigator.clipboard !== undefined) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          alert('클립보드로 복사되었읍니다\n\n'+ text);
        });
    } else {
      alert( text);
    }
  };
*/
const copyToClipboard = async (text) => {
  try {
    await Clipboard.setString(text);
    alert('클립보드로 복사되었읍니다\n\n'+ text);
  } catch (e) {
    alert('복사에 실패하였습니다');
  }
}


  const getNewPassword = () => {
    modals.openConfirmModal({
      title: "임시 비밀번호 발급",
      children: <Center>임시 비밀번호를 발급 받으시겠습니까?</Center>,
  //    centered: true,
      zIndex: 2000,
      labels: { confirm: "확인", cancel: "취소" },
      onConfirm: () => {
        requestNewPassword(defaultValues)
        .then(res => copyToClipboard(res));
        backToList();
      },
    });
  };

  const onDelete = () => {
    modals.openConfirmModal({
      title: "삭제",
   //   centered: true,
      zIndex: 2000,
      children: (
        <Center>
          <Text>정말 삭제하시겠습니까? (삭제 후 복구불가)</Text>
        </Center>
      ),
      labels: { confirm: "삭제", cancel: "취소" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        deleteUserInfo(username);
        backToList();
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Flex
          style={{
            width: "100%",
            justifyContent: "space-between",
            gap: "80px",
          }}
        >
          <Button color="red" onClick={() => onDelete()}>
            삭제
          </Button>
          <Button type="submit">수정</Button>
          <Button variant="outline" onClick={() => getNewPassword()}>
            임시 비밀번호 발급
          </Button>
        </Flex>
      </Center>
    );
  };

  return (
    <>
    <SRD_Form
      fields={fields}
      onSubmit={onSubmit}
      submitButton={<SubmitButton />}
      defaultValues={defaultValues}
    />
    </>
  );
}

export default UserEditForm;
